import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const brands = [{
  name: 'Mercedes-Benz',
  image: 'https://images.unsplash.com/photo-1618843479313-40f8afb4b4d8?q=80&w=2070&auto=format&fit=crop',
  description: 'Tiêu chuẩn của xe sang trọng'
}, {
  name: 'Mercedes-AMG',
  image: 'https://images.unsplash.com/photo-1609520505218-7421da4c3c7c?q=80&w=2070&auto=format&fit=crop',
  description: 'Hiệu suất vượt trội'
}, {
  name: 'Mercedes-Maybach',
  image: 'https://images.unsplash.com/photo-1622199583626-47636e3d2313?q=80&w=2070&auto=format&fit=crop',
  description: 'Đỉnh cao của sự độc quyền'
}];
export function BrandCategory() {
  return <section className="py-24 bg-white" data-id="element-49">
      <div className="max-w-7xl mx-auto px-6" data-id="element-50">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-51">
          <h2 className="text-3xl md:text-4xl font-light text-black mb-4" data-id="element-52">
            CÁC THƯƠNG HIỆU
          </h2>
          <div className="w-24 h-[1px] bg-[#D4AF37] mx-auto" data-id="element-53" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-54">
          {brands.map((brand, index) => <motion.div key={brand.name} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="group cursor-pointer" data-id="element-55">
              <div className="relative h-[400px] overflow-hidden mb-6 rounded-2xl" data-id="element-56">
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors z-10" data-id="element-57" />
                <img src={brand.image} alt={brand.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-58" />
                <div className="absolute bottom-0 left-0 right-0 p-8 z-20" data-id="element-59">
                  <h3 className="text-white text-2xl font-light mb-2" data-id="element-60">
                    {brand.name}
                  </h3>
                  <div className="w-0 group-hover:w-full h-[1px] bg-white transition-all duration-500" data-id="element-61" />
                </div>
              </div>
              <p className="text-gray-600 font-light mb-4" data-id="element-62">
                {brand.description}
              </p>
              <div className="flex items-center text-sm tracking-widest uppercase font-medium group-hover:text-[#D4AF37] transition-colors" data-id="element-63">
                Khám Phá <ArrowRight className="ml-2 w-4 h-4" data-id="element-64" />
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}